import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler } from '../../base/decorators';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import GroupShareRepository from '../repository/group-share-repository';
var GroupShareEntity = /** @class */ (function () {
    function GroupShareEntity(docMetaDomainService, networkRequest) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequest = networkRequest;
        this.groupShareRepository = new GroupShareRepository(docMetaDomainService, networkRequest);
    }
    GroupShareEntity.prototype.fetchGroupList = function (start, limit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.fetchGroupList(start, limit)];
            });
        });
    };
    GroupShareEntity.prototype.fetchGroupMembers = function (groupId, start, limit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.fetchGroupMembers(groupId, start, limit)];
            });
        });
    };
    GroupShareEntity.prototype.modifyGroup = function (groupId, groupName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.modifyGroup(groupId, groupName)];
            });
        });
    };
    GroupShareEntity.prototype.deleteGroupMember = function (groupId, memberTinyId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.deleteGroupMember(groupId, memberTinyId)];
            });
        });
    };
    GroupShareEntity.prototype.removeGroup = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.removeGroup(groupId)];
            });
        });
    };
    GroupShareEntity.prototype.addGroupMember = function (groupId, groupMemberList) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.addGroupMember(groupId, groupMemberList)];
            });
        });
    };
    GroupShareEntity.prototype.createGroup = function (groupName, isTemp) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.createGroup(groupName, isTemp)];
            });
        });
    };
    GroupShareEntity.prototype.fetchGroupInfo = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.fetchGroupInfo(groupId)];
            });
        });
    };
    GroupShareEntity.prototype.quitGroup = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.quitGroup(groupId)];
            });
        });
    };
    GroupShareEntity.prototype.checkCreateGroup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.checkCreateGroup()];
            });
        });
    };
    GroupShareEntity.prototype.addKeyToGroup = function (groupId, shareKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.addKeyToGroup(groupId, shareKey)];
            });
        });
    };
    GroupShareEntity.prototype.activateGroup = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.groupShareRepository.activateGroup(groupId)];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Number]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "fetchGroupList", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Number, Number]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "fetchGroupMembers", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "modifyGroup", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "deleteGroupMember", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "removeGroup", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Array]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "addGroupMember", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Boolean]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "createGroup", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "fetchGroupInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "quitGroup", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "checkCreateGroup", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "addKeyToGroup", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], GroupShareEntity.prototype, "activateGroup", null);
    GroupShareEntity = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], GroupShareEntity);
    return GroupShareEntity;
}());
export default GroupShareEntity;
